import { useQuery } from '@tanstack/react-query';

import { userQueryKey } from '@/lib/query-keys';
import { useAuthStore } from '@/stores/auth-store';

import type { Creator } from '../types';

import { getOrCreateCreator } from './creator-service';

export const useUser = () => {
  const firebaseUser = useAuthStore((s) => s.firebaseUser);

  return useQuery({
    queryKey: userQueryKey,
    queryFn: async (): Promise<Creator | null> => {
      if (!firebaseUser) return null;
      const { creator } = await getOrCreateCreator();
      return creator;
    },
    enabled: !!firebaseUser?.emailVerified,
  });
};
